import styled, { css } from 'styled-components';
import Button from '../Button';
import Flex from '../Flex';
import KiperRadioCustomButton from '../KiperRadioCustomButton';
import BaseTable from '../Table';
import BaseText from '../Text';

export const statusStyles = props => {
  const styles = {
    [props.status.AUTHORIZED]: {
      borderColor: props.theme.colors.success500,
      textColor: props.theme.colors.success500,
      hoverBorderColor: props.theme.colors.success900,
      hoverTextColor: props.theme.colors.success900,
    },
    [props.status.NOT_AUTHORIZED]: {
      borderColor: props.theme.colors.danger500,
      textColor: props.theme.colors.danger500,
      hoverBorderColor: props.theme.colors.danger900,
      hoverTextColor: props.theme.colors.danger900,
    },
    [props.status.UNAVAILABLE_CONTACTS]: {
      borderColor: props.theme.colors.warning500,
      textColor: props.theme.colors.warning500,
      hoverBorderColor: props.theme.colors.warning900,
      hoverTextColor: props.theme.colors.warning900,
    },
    [props.status.AT_THE_CONCIERGE]: {
      borderColor: props.theme.colors.info500,
      textColor: props.theme.colors.info500,
      hoverBorderColor: props.theme.colors.info900,
      hoverTextColor: props.theme.colors.info900,
    },
    default: {
      borderColor: props.theme.colors.semantic.action.primary,
      textColor: props.theme.colors.semantic.action.primary,
      hoverBorderColor: props.theme.colors.semantic.action.primary,
      hoverTextColor: props.theme.colors.semantic.action.primary,
    },
  };
  return styles;
};

export const Container = styled(Flex)`
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const ContainerCall = styled(Flex)`
  flex-direction: column;
  width: 100%;
  border: 1px solid ${props => props.theme.colors.secondary300};
  border-radius: 8px;
  gap: 16px;
`;

export const Text = styled(BaseText)`
  font-family: 'Nunito Sans';
  font-weight: ${({ weight }) => weight || 400};
  font-size: ${({ size }) => size || '14px'};
  opacity: 1;
  color: ${props =>
    props.color
      ? props.theme.colors[props.color]
      : props.theme.colors.semantic.text.primary};

  -webkit-transition: opacity 0.6s;
  transition: opacity 0.6s;
`;

export const ActionButton = styled(KiperRadioCustomButton)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 7px;
  padding-right: 7px;
  border-radius: 4px;
  height: 32px;
  box-sizing: border-box;
  border: 1px solid ${props => props.theme.colors.semantic.border.default};
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
  box-shadow: none;
  transition: all 0.3s;

  > span,
  > svg {
    color: ${({ theme }) => theme.colors.semantic.text.primary} !important;
    stroke: ${({ theme }) => theme.colors.semantic.text.primary} !important;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
    border-color: ${({ theme }) => theme.colors.semantic.text.primary};
    > span,
    > svg {
      color: ${({ theme }) => theme.colors.semantic.text.primary} !important;
      stroke: ${({ theme }) => theme.colors.semantic.text.primary} !important;
    }
  }

  ${props =>
    props.checked &&
    css`
      box-shadow: 0 0 0 1px
        ${statusStyles(props)[props.value]?.borderColor ||
          statusStyles(props).default.borderColor};
      background-color: ${props.theme.colors.semantic.surface.card} !important;
      border-color: ${statusStyles(props)[props.value]?.borderColor ||
        statusStyles(props).default.borderColor} !important;

      > span,
      > svg {
        color: ${statusStyles(props)[props.value]?.textColor ||
          statusStyles(props).default.textColor} !important;
        stroke: ${statusStyles(props)[props.value]?.textColor ||
          statusStyles(props).default.textColor} !important;
      }

      &:hover {
        background-color: ${props.theme.colors.semantic.surface
          .muted} !important;
        color: ${statusStyles(props)[props.value]?.hoverTextColor ||
          statusStyles(props).default.hoverTextColor} !important;
        border-color: ${statusStyles(props)[props.value]?.hoverBorderColor ||
          statusStyles(props).default.hoverBorderColor} !important;

        > span,
        > svg {
          color: ${statusStyles(props)[props.value]?.hoverTextColor ||
            statusStyles(props).default.hoverTextColor} !important;
          stroke: ${statusStyles(props)[props.value]?.hoverTextColor ||
            statusStyles(props).default.hoverTextColor} !important;
        }
      }
    `};
`;

export const Table = styled(BaseTable)`
  border-bottom: none;
  thead {
    background: ${({ theme }) => theme.colors.tableHeader};
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondary400};
  }
`;

export const LoaderContainer = styled(Flex)`
  justify-content: center;
  width: 100%;
  align-items: center;
  @media screen and (min-height: 625px) {
    height: 220px;
  }
  @media screen and (min-height: 700px) {
    height: 294px;
  }
  @media screen and (min-height: 768px) {
    height: 374px;
  }
  @media screen and (min-height: 937px) {
    height: 544px;
  }
`;

export const TableContainer = styled(Flex)`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100px;

  @media screen and (min-height: 625px) {
    max-height: 220px;
  }
  @media screen and (min-height: 700px) {
    max-height: 294px;
  }
  @media screen and (min-height: 768px) {
    max-height: 374px;
  }
  @media screen and (min-height: 937px) {
    max-height: 544px;
  }
`;

export const TR = styled.tr`
  ${({ current, theme }) =>
    current &&
    css`
      background-color: ${theme.colors.tableBg};
    `}
`;

export const TextEllipsis = styled.span`
  display: inline-block;
  max-width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (width: 1366px) {
    max-width: 162px;
  }

  @media screen and (width: 1600px) {
    max-width: 220px;
  }
`;

export const CallButton = styled(Button)`
  border-radius: 500px;
  padding-left: 7px;
  padding-right: 7px;

  background: ${({ theme, called }) => called && theme.colors.primary50};

  &:hover {
    ${({ disabled, theme }) =>
      !disabled &&
      css`
        background: ${theme.colors.primary50};
        svg {
          color: ${theme.colors.primary600} !important;
          stroke: ${theme.colors.primary600} !important;
        }
      `}
  }

  svg {
    height: 16px;
    width: 16px;
  }
`;

export const ObservationButton = styled(Button)`
  border-radius: 500px;
  cursor: help !important;
  padding-left: 7px;
  padding-right: 7px;

  span {
    color: ${props => props.theme.colors.highBlack} !important;
  }
`;
